'use cient';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useMemo } from 'react';

import type { Component } from './types';
import { createMappingSearchParams } from './utils';

export const DynamicEyeotaScript: Component = ({
  pid,
  targetMapping,
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const mappingSearchParams = useMemo(() => {
    if (!targetMapping) return null;

    return `${createMappingSearchParams(targetMapping)}`;
  }, [targetMapping]);

  useEffect(() => {
    const oldScript = document.getElementById('eyeota-script');

    oldScript?.remove();

    const newScript = document.createElement('script');

    newScript.src = `https://ps.eyeota.net/pixel?pid=${pid}&t=ajs${mappingSearchParams ? `&${mappingSearchParams}` : ''}`;
    newScript.id = 'eyeota-script';
    newScript.async = true;
    newScript.defer = true;
    document.body.appendChild(newScript);

    return () => {
      const scriptToRemove = document.getElementById('eyeota-script');

      scriptToRemove?.remove();
    };
  }, [mappingSearchParams, pathname, pid, searchParams]);

  return null;
};
